/* eslint-disable import/no-cycle */
import Parent from '../views/Parent.vue';
import ListMonitoringMerchant from '../views/monitoring-merchant/ListMonitoringMerchant.vue';
import { setBreadcrumb } from './index';

const monitoringMerchant = {
  path: '/monitoring-merchant',
  children: [
    {
      path: '',
      meta: {
        title: 'BNI QRIS - Monitoring Merchant',
        appBarTitle: 'Monitoring Merchant',
        breadcrumbs: () => [
          setBreadcrumb('Monitoring Merchant', '/monitoring-merchant', true),
          setBreadcrumb('List Monitoring Merchant', '/monitoring-merchant'),
        ],
      },
      component: ListMonitoringMerchant,
      name: 'ListMonitoringMerchant',
    },
  ],

  meta: {
    title: 'BNI QRIS - Monitoring Merchant',
    appBarTitle: 'Monitoring Merchant',
  },
  component: Parent,
};
export default monitoringMerchant;
